import { render, staticRenderFns } from "./OtherDeliveries.vue?vue&type=template&id=63f84e2e"
import script from "./OtherDeliveries.vue?vue&type=script&lang=js"
export * from "./OtherDeliveries.vue?vue&type=script&lang=js"
import style0 from "./OtherDeliveries.vue?vue&type=style&index=0&id=63f84e2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports